import { render, staticRenderFns } from "./MerchantTable.vue?vue&type=template&id=0330bf7f"
import script from "./MerchantTable.vue?vue&type=script&lang=js"
export * from "./MerchantTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports